import React from 'react'
import { CartesianGrid, Line, LineChart, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import './index.scss'
import DashboardNoDataInfo from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo'
import { DistributionPaid } from '@Entities/processing/distribution-paid'
import day from 'dayjs'

interface DashboardRoyaltiesGraphProps {
    data: DistributionPaid[]
}

const DashboardRoyaltiesGraph = ({ data }: DashboardRoyaltiesGraphProps) => (
    <div className="dashboard-content-card royalties-graph">
        <div className="royalties-graph-title">
            <div>Your amount paid over time</div>
            <div>Last 6 months</div>
        </div>

        {data?.length ? (
            <div className="royalties-graph-area">
                <ResponsiveContainer width="100%" aspect={2.5}>
                    <LineChart data={data} margin={{ top: 30, right: 40, left: 40, bottom: 10 }}>
                        <CartesianGrid stroke="#ccc" />
                        <Line
                            name="Amount Paid"
                            type="linear"
                            stroke="#0e52b7"
                            strokeWidth={2}
                            dot={{ fill: '#0e52b7', fillOpacity: 1, z: 999 }}
                            dataKey="amount"
                        />
                        <XAxis
                            dataKey="distributionId"
                            tickFormatter={(val) => day(val, 'YYYY-MM').format("MMM [']YY")}
                        />
                        <YAxis
                            tickFormatter={(val) =>
                                Intl.NumberFormat('en-US', {
                                    notation: 'compact',
                                    style: 'currency',
                                    currency: 'USD',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 1,
                                }).format(val)
                            }
                        />
                        <Tooltip
                            labelFormatter={(val) =>
                                typeof val === 'string' || typeof val === 'number'
                                    ? day(val, 'YYYY-MM').format('MMM YYYY')
                                    : ''
                            }
                            formatter={(otherVal) =>
                                otherVal?.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            }
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        ) : (
            <DashboardNoDataInfo type="royalty data" />
        )}
    </div>
)

export default DashboardRoyaltiesGraph
